module.exports = __webpack_public_path__ + "static/img/item_back_bg_orange.847b2f52.svg";